// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class U64 implements flatbuffers.IUnpackableObject<U64T> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): U64 {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsU64(bb: flatbuffers.ByteBuffer, obj?: U64): U64 {
    return (obj || new U64()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsU64(bb: flatbuffers.ByteBuffer, obj?: U64): U64 {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new U64()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  static startU64(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: bigint) {
    builder.addFieldInt64(0, value, 0n);
  }

  static endU64(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createU64(builder: flatbuffers.Builder, value: bigint): flatbuffers.Offset {
    U64.startU64(builder);
    U64.addValue(builder, value);
    return U64.endU64(builder);
  }

  unpack(): U64T {
    return new U64T(this.value());
  }

  unpackTo(_o: U64T): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): U64T {
    const t = new U64T();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class U64T implements flatbuffers.IGeneratedObject {
  constructor(public value: bigint = 0n) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return U64.createU64(builder, this.value);
  }

  clone(): U64T {
    const obj = new U64T();
    obj.value = this.value;
    return obj;
  }

  equals(other: U64T): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyU64(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
  } finally {
    verifier.popDepth();
  }
}
